<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'quotationModelManagement',
})
</script>
<template>
  <div>
    <a-card>
      <div class="quotation-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="模型名称">
                <a-input v-model:value="state.tableData.param.modelName" placeholder="请输入模型名称" :maxlength="100"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="省/市">
                <a-tree-select v-model:value="state.tableData.param.areaId" :tree-data="areaTreeData"
                  :field-names="{ children: 'children', value: 'id', label: 'label', key: 'id' }" placeholder="请选择区域"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action flex flex-nowrap">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun mr-[10px]!" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <div class="card-col-action flex justify-start md:justify-end">
                <ant-button class="add" @click="openDialog('add', {})" type="primary" v-auth="'quotation.model.add'">
                  <PlusOutlined />新增模型
                </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">{{ index + 1 }}</template>
          <template v-if="column.key === 'sizeEnabled'">{{ record.sizeEnabled == '0' ? '关闭' : record.sizeEnabled == '1'
            ?
            '开启' : '' }}</template>
          <template v-if="column.key === 'industryEnabled'">{{ record.industryEnabled == '0' ? '关闭' :
            record.industryEnabled == '1' ?
              '开启' : '' }}</template>
          <template v-else-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="openDialog('edit', record)"
                v-auth="'quotation.model.edit'">编辑</a-button>
              <a-button type="link" size="small" danger @click="onDelete(record)"
                v-auth="'quotation.model.del'">删除</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
    </a-card>
    <QuotationModelDialog ref="dialogRef" :area-tree-data="areaTreeData" @create-update="createUpdate" />
  </div>
</template>

<script setup lang="ts" name="quotationModelManagement">
import { reactive, ref, onMounted, h, provide } from 'vue'
import { message, Modal } from 'ant-design-vue'
import { SearchOutlined, RedoOutlined, PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useQuotation } from '@/store/quotation/quotation'
import { useDictionary } from '@/store/system/dictionary'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import QuotationModelDialog from './dialog.vue'
import { useStoreType } from '@/store/shop/storeType'

const storeTypeStore = useStoreType()

const quotationStore = useQuotation()
const dictionaryStore = useDictionary()
const dialogRef = ref()

const columns = [
  { title: '序号', key: 'index', width: 60 },
  { title: '模型名称', dataIndex: 'modelName', key: 'modelName', ellipsis: true },
  { title: '省/市', dataIndex: 'areaStr', key: 'areaStr', ellipsis: true },
  { title: '单价', dataIndex: 'unitPrice', key: 'unitPrice', width: 120, align: 'center' },
  { title: '城市系数', dataIndex: 'coefficient', key: 'coefficient', width: 120, align: 'center' },
  { title: '面积设置', dataIndex: 'sizeEnabled', key: 'sizeEnabled', width: 120, align: 'center' },
  { title: '行业设置', dataIndex: 'industryEnabled', key: 'industryEnabled', width: 120, align: 'center' },
  { title: '更新时间', dataIndex: 'modifyTime', key: 'modifyTime', width: 170 },
  { title: '操作', key: 'action', width: 150 }
]

const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      modelName: '',
      areaId: undefined as number | undefined
    }
  }
})

const stateT = reactive({
  sizeDictCodeList: [] as any[],
  venueTypeData: [] as any[]
})

const areaTreeData = ref<any[]>([])

const fetchAreaTree = async () => {
  try {
    const data: any = await dictionaryStore.getAreaTree()
    const list = data || []
    areaTreeData.value = list
      .filter((item: any) => item.level === '1')
      .map((item: any) => ({
        ...item,
        children: (item.children || []).filter((c: any) => c.level === '2').map((c: any) => ({ ...c, children: [] }))
      }))
  } catch (err) {
    console.error('获取区域树失败', err)
    areaTreeData.value = []
  }
}

const resetFun = () => {
  state.tableData.param.modelName = ''
  state.tableData.param.areaId = undefined
  state.tableData.param.pageNum = 1
}

const getTableData = async () => {
  state.tableData.loading = true
  try {
    const params: any = { ...state.tableData.param }
    const data: any = await fetchWithPaginationFallback(
      (param) => quotationStore.getQuotationModelPage(param),
      params
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const openDialog = (type: string, row: any) => {
  if (type === 'add') {
    dialogRef.value.openDialog(type, row)
  } else {
    quotationStore.getQuotationModelInfo(row.id).then((data: any) => {
      dialogRef.value.openDialog(type, data)
    })
  }
}

const onDelete = (row: any) => {
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: `此操作将永久删除报价模型："${row.modelName}"，是否继续?`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return quotationStore.deleteQuotationModel(row.id).then(() => {
        message.success('删除成功')
        getTableData()
      })
    }
  })
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

const createUpdate = () => {
  message.success('操作成功')
  getTableData()
  dialogRef.value.closeDialog()
}

const init = async () => {
  await fetchAreaTree()
  getTableData()
  const data: any = await dictionaryStore.getDict({ code: 'quotation_build_area' })
  stateT.sizeDictCodeList = data || []
  const venueTypeData: any = await storeTypeStore.getStoreTypeTree({ typeGroup: 'venue' })
  stateT.venueTypeData = venueTypeData || []
}

onMounted(() => {
  init()
})

provide('stateT', stateT)
</script>

<style scoped lang="less">
.ml10 {
  margin-left: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt15 {
  margin-top: 15px;
}

.btn-group {
  display: flex;
  white-space: nowrap;
}
</style>
